import * as React from "react"
import Footer from "./footer"
import Navbar from "./navbar"
import Seo from './seo'

const Layout = ({ children }) => {
	return (
		<div>
			<Seo 
				title={"Let's Celebrate"}
				description={"Let's Celebrate - Chạm đến trái tim bằng sự sáng tạo"}
				image={`https://khan-web-prod.s3.ap-southeast-1.amazonaws.com/static/Cover-Lets-Celebrate.png`}
				url={`https://letscelebrate.vn/home`}
			/>
			<Navbar></Navbar>
			<div className='content-page mt-16 xxs:mt-32 md:mt-16 lg:mt-16 mx-auto'>
				{children}
				<Footer></Footer>
			</div>
			
		</div>
	)
}

export default Layout
